<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{ $t('Users') }}</h1>
          <h2 class="page-subtitle">{{ $t('Total') }} : {{ totalCount }}</h2>
        </div>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableUser"
          identifier="B122TableUser"
          init-b122-table-url="/user/initB122Table"
          get-b122-table-results-url="/user/getB122TableResults"
          :fields="tableFields"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        >

          <template #cell(nbQuestionnaireRestant)="data">
            <div v-if="data.value===0" style="color:red">{{ data.value }}</div>
            <div v-else>{{ data.value }}</div>
          </template>

        </b122-table>
      </b-card>
    </b-container>
    <User-delete-modal :selectedUser="ui.selectedUser" @didDeleteUser="didDeleteUser()"></User-delete-modal>
  </div>
</template>

<script>

import B122Table from "../../components/b122/B122Table";
import UserDeleteModal from "./UserDeleteModal";

export default {

  name: 'UserIndex',

  components: {
    B122Table,
    UserDeleteModal
  },

  data() {
    return {
      totalCount: 0,

      tableFields: [
        {
          key: "show",
          sortable: false
        },
        {
          label: this.$i18n.t('user.FirstName'),
          key: "firstName",
          sortable: true
        },
        {
          label: this.$i18n.t('user.LastName'),
          key: "lastName",
          sortable: true
        },
        {
          label: this.$i18n.t('user.Username'),
          key: "username",
          sortable: true
        },
        {
          label: this.$i18n.t('user.PartnerCode'),
          key: "partnerCode",
          sortable: true
        },
        {
          label: this.$i18n.t('user.NbQuestionnaireRestant'),
          key: "nbQuestionnaireRestant",
          sortable: true,
          formatter: function (value, key, item) {
            return item.isUnlimited ? "Illimité" : item.nbQuestionnaireRestant;
          }
        },
        {
          label: "",
          key: "actions"
        }
      ],
      ui: {
        selectedUser: null
      }
    }
  },

  methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'UserShow',
        params: {
          userId: row.item.id
        }
      })
    },


    clickOnEditBtn(row) {
      this.$router.push({
        name: 'UserEdit',
        params: {
          userId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selectedUser = row.item
      this.$bvModal.show('user-delete-modal')
    },

    didDeleteUser() {
      this.ui.selectedUser = null;
      this.$refs.B122TableUser.refreshTable()
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/UserIndex.vue